$(function () {
  const announcementBar = document.querySelector('.announcement-bar__container');
  if(!announcementBar) {
    return;
  }

  new Swiper(announcementBar, {
    loop: true,
    direction: 'vertical',
    speed: 800,
    autoplay: {
      delay: 3000,
      reverseDirection: true,
      disableOnInteraction: false,
    },
    allowTouchMove: false,
    noSwiping: true
  });
});
